import {
  ADD_PUP_SUBPATH,
  EDIT_PET_SUBPATH,
  DELETE_PET_SUBPATH,
} from '../../routing';
import { isCompletePet } from '../guard';

export const shouldDefaultShowPlanSelection = subpath =>
  subpath === EDIT_PET_SUBPATH;

export const isCartMutatingSubpath = subpath =>
  subpath === DELETE_PET_SUBPATH ||
  subpath === EDIT_PET_SUBPATH ||
  subpath === ADD_PUP_SUBPATH;

export const isReturningSession = ({ petId, subpath }) =>
  Boolean(petId) && !isCartMutatingSubpath(subpath);

export const resolveInitialLoadSourceCart = ({
  showQuizAbandonerMenu,
  cachedCart,
  liveCart,
  subpath,
}) => {
  const liveCartReady = Boolean(liveCart?.cart_id);
  const canUseCachedCart =
    showQuizAbandonerMenu &&
    Boolean(cachedCart) &&
    !liveCartReady &&
    !isCartMutatingSubpath(subpath);

  if (liveCartReady) {
    return liveCart;
  }

  if (canUseCachedCart) {
    return cachedCart;
  }

  return null;
};

export const resolveInitialLoadPet = ({ sourceCart, pet_id, pet }) => {
  const fallbackPet =
    sourceCart.pets?.find(candidate => candidate?.id === pet_id) ??
    sourceCart.pets?.find(candidate => !isCompletePet(candidate)) ??
    sourceCart.pets?.find(candidate => !candidate?.starter_box) ??
    sourceCart.pets?.[0];

  return {
    pet: pet ?? fallbackPet,
    pet_id: pet_id ?? fallbackPet?.id,
  };
};

export const resolveElevarCartTotal = cart =>
  cart?.total || cart?.subtotal || '0.00';
